const settings = {
  btnSave: 'Guardar',
  off: 'Apagado',
  btnRestoreDefault: 'Restaurar configuración predeterminada',

  btnAdvance: {
    show: 'Mostrar avanzado',
    hide: 'Ocultar avanzado',
  },

  general: {
    title: 'General',
    pageTitle: 'Configuraciones Generales',
    groups: {
      general: {
        title: 'General',
        parameters: {
          timezone: {
            label: 'Zona horaria',
            description: 'El sistema',
          },
          defaultLanguage: {
            label: 'Idioma predeterminado',
            description:
              'Idioma preferido: se aplicará al cambiar la vista del sitio, actualizar o iniciar sesión, si no se establece una preferencia de usuario.',
          },
          systemType: {
            label: 'Tipo de sistema',
            description: 'Cambiar entre unidades imperiales y métricas para personalizar la visualización de distancias en el sistema.',
            options: {
              imperial: 'Imperial',
              metric: 'Métrico',
            },
          },
          addressType: {
            label: 'Tipo de campo de dirección',
            description:
              'Personaliza cómo se completan las direcciones. "Google" permite el autocompletado desde Google, "Ubicación" completa automáticamente las ubicaciones guardadas en el sistema.',
            options: {
              both: 'Both',
              google: 'Google',
              location: 'Location',
            },
          },
          enableLocationTimezone: {
            label: 'Habilitar zona horaria por ubicación',
            description:
              'Cuando está habilitado, el sistema determina la zona horaria a partir de la ubicación de la reserva en lugar de usar la zona horaria predeterminada del sistema.',
          },
        },
      },
      auth: {
        title: 'Autenticación',
        parameters: {
          twoFA: {
            label: 'Aplicar autenticación de dos factores (2FA)',
            description: 'Cuando está habilitado, todos los usuarios deben realizar autenticación de dos factores en dispositivos nuevos.',
          },
        },
      },
      booking: {
        title: 'Reservas',
        parameters: {
          preventDuplications: {
            label: 'Advertencia de duplicación de reserva',
            description:
              'Habilita para recibir una advertencia emergente al completar una reserva con detalles idénticos o deshabilita para desactivar esta alerta.',
          },
          isWaitAndReturnEnabled: {
            label: 'Habilitar espera y retorno',
            description: '',
          },
        },
      },
      map: {
        title: 'Mapa',
        parameters: {
          mapStyle: {
            label: 'Estilo de mosaicos del mapa',
            description: 'Elige la imagen de mosaico utilizada en todos los mapas de la plataforma',
            options: {
              lightDark: 'Claro / Oscuro',
              streets: 'Calles',
              satellite: 'Satélite',
            },
          },
          mapServer: {
            label: 'Servidor de mapas',
            description: 'Servidor de mapas OSRM',
          },
          graphhopperEnabled: {
            label: 'Habilitar Graphhopper',
            description:
              'Cuando está habilitado, el sistema utiliza Graphhopper como servidor de mapas para el enrutamiento. Cuando está deshabilitado, se utiliza OSRM.',
          },
          mapCenter: {
            label: 'Centro del mapa',
            description: 'Establecer el punto central predeterminado para la vista del mapa.',
          },
          mapZoom: {
            label: 'Zoom del mapa',
            description: 'El zoom predeterminado para los mapas en la plataforma.',
          },
        },
      },
    },
  },
  routing: {
    title: 'Enrutamiento',
    pageTitle: 'Configuraciones de Enrutamiento',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          sharedRideRatio: {
            label: 'Proporção Máxima de Tempo Compartilhado',
            description:
              'Proporção máxima permitida entre o tempo de viagem solo e o tempo de viagem compartilhado (ex.: 1,5 = até 50% mais longo que o solo)',
          },
          sharedRideDifferenceLimit: {
            label: 'Tempo Extra Máximo Compartilhado',
            description:
              'Número máximo de minutos que podem ser adicionados ao tempo da viagem solo quando o passageiro está em uma viagem compartilhada',
          },
          maxSharedDistanceRatio: {
            label: 'Proporção Máxima de Distância Compartilhada',
            description:
              'Define quanto uma viagem compartilhada pode ser mais longa em comparação com a distância solo. Exemplo: Se a distância solo é 1 milha e a proporção é 1,2x, a viagem compartilhada não pode exceder 1,2 milhas',
          },
          maxTripStops: {
            label: 'Paradas máximas',
            description: 'Número máximo de ubicaciones de paradas por viaje.',
          },
          maxPickupStops: {
            label: 'Recogidas máximas',
            description: 'Número máximo de paradas de recogida por viaje.',
          },
          maxDropoffStops: {
            label: 'Entregas máximas',
            description: 'Número máximo de paradas de entrega por viaje.',
          },
          maxTripDuration: {
            label: 'Duración máxima',
            description: 'Duración máxima de un viaje en minutos.',
          },
          maxSinglePassengerTime: {
            label: 'Tiempo Máximo de Viaje para Pasajero Único',
            description: '',
          },
          maxPassengers: {
            label: 'Pasajeros máximos',
            description: 'Número máximo de pasajeros en todo el viaje.',
          },
          maxPassengersAtOnce: {
            label: 'Pasajeros máximos al mismo tiempo',
            description:
              'Número máximo de pasajeros permitidos al mismo tiempo (un asiento estará libre/usado en la entrega/recogida de pasajeros).',
          },
          tripBoardingTime: {
            label: 'Tiempo de abordaje',
            description:
              'El tiempo que lleva recoger a un pasajero en su parada (este parámetro impactará en la duración total del viaje).',
          },
          subsequentPickTime: {
            label: 'Tiempo de abordaje secundario',
            description: 'Cuando la configuración está desactivada, los tiempos de abordaje siguen la norma general.',
          },
          tripDropOffTime: {
            label: 'Tiempo de entrega',
            description: 'El tiempo que lleva dejar a un pasajero en su parada (este parámetro impactará en la duración total del viaje).',
          },
          subsequentDropOffTime: {
            label: 'Tiempo de entrega secundario',
            description: 'Cuando la configuración está desactivada, los tiempos de entrega siguen la norma general.',
          },
          maxBoardingDelay: {
            label: 'Retraso máximo de abordaje',
            description:
              'Número máximo de minutos que un conductor puede llegar tarde respecto al tiempo de recogida establecido en la reserva.',
          },
          maxBoardingEarly: {
            label: 'Adelanto máximo de abordaje',
            description:
              'Número máximo de minutos que un conductor puede adelantarse respecto al tiempo de recogida establecido en la reserva.',
          },
          onlyPrivate: {
            label: 'Solo privado',
            description: 'Hacer todos los viajes privados',
          },
        },
      },
      advanced: {
        title: 'Avanzado',
        parameters: {
          tripsJoinMode: {
            label: 'Intentar unir',
            description:
              'Decidir si el motor intentará unir nuevas reservas a viajes existentes: No Unir = 0, Intentar Unir = 1, Solo Unir = 2',
            options: {
              dontJoin: 'No Unir',
              tryJoin: 'Intentar Unir',
              onlyJoin: 'Solo Unir',
            },
          },
          maxJoinRadius: {
            label: 'Intentar unir - Radio',
            description: 'Define el radio máximo en el que intentamos buscar viajes existentes para unir a una reserva.',
          },
          maxJoinTimeRange: {
            label: 'Intentar unir - Rango de tiempo',
            description: 'Los viajes existentes que estén más allá de este límite serán considerados para intentar unir.',
          },
          maxReservationsAtOnce: {
            label: 'Máximo de reservas al mismo tiempo',
            description: 'Número máximo de reservas permitidas en el vehículo al mismo tiempo.',
          },
          minReservationDistance: {
            label: 'Distancia mínima de reserva',
            description:
              'Distancia mínima (en metros) que debe tener una reserva entre la recogida y la entrega para ser incluida en la ruta. Las reservas con una distancia menor serán completamente ignoradas por el motor.',
          },
          maxEmptyTripTime: {
            label: 'Tiempo vacío máximo',
            description: 'Número máximo de minutos permitidos para que un viaje esté vacío entre paradas.',
          },
          maxDropOffEarly: {
            label: 'Adelanto máximo de entrega',
            description:
              'Número máximo de minutos que un conductor puede adelantarse respecto al tiempo de entrega establecido en la reserva.',
          },
          maxDropOffDelay: {
            label: 'Retraso máximo de entrega',
            description:
              'Número máximo de minutos que un conductor puede llegar tarde respecto al tiempo de entrega establecido en la reserva.',
          },
          pickPhaseRadius: {
            label: 'Rango de radio de recogida',
            description:
              'Define la distancia máxima permitida (en kilómetros o millas) entre la primera recogida y las siguientes. Las reservas con recogidas fuera de este radio no se combinarán.',
          },
          pickPhaseMinutes: {
            label: 'Rango de minutos de recogida',
            description:
              'Define el tiempo máximo (en minutos) permitido entre la primera recogida y las siguientes. Si la diferencia de tiempo supera este umbral, las reservas no se combinarán.',
          },
          groupWaitAndReturn: {
            label: 'Agrupar espera y retorno',
            description:
              '• Apagado: Sin agrupación alguna; los viajes de ida y retorno se enrutan por separado.\n\n• Pareja individual Agrupar cada viaje de ida y retorno juntos en un solo viaje.\n\n• Múltiples parejas Agrupar múltiples parejas de ida y retorno, permitiendo que varias parejas de espera y retorno se enrutuen en un solo viaje.',
            options: {
              off: 'Apagado',
              individualPair: 'Agrupación de Parejas Individuales',
              multiplePairs: 'Agrupación de Múltiples Parejas',
            },
          },
          pickupAllBeforeDropping: {
            label: 'Recoger a todos',
            description: 'Cuando se establece en verdadero, el viaje recogerá primero a todos los pasajeros y luego comenzará a dejarlos.',
          },
          waitForBoardingTime: {
            label: 'Esperar tiempo de abordaje',
            description: 'Al llegar a una parada, el conductor esperará hasta el tiempo exacto de recogida, si es necesario.',
          },
          sortStopsByPickupTime: {
            label: 'Ordenar por tiempo de recogida',
            description:
              'Cuando se establece en verdadero, todas las paradas del viaje se ordenarán solo por el tiempo de recogida y no geográficamente.',
          },
          balanceDepartureTime: {
            label: 'Normalizar salida',
            description: 'Ajusta el tiempo de salida para que los pasajeros',
          },
          angleDuration: {
            label: 'Duración del ángulo',
            description:
              'Evita enrutamiento de tramos que duren más minutos que el tiempo de duración de ángulo y estén en un ángulo mayor al especificado.',
          },
          angleMax: {
            label: 'Ángulo máximo',
            description:
              'Evita enrutamiento de tramos que duren más minutos que el tiempo de duración de ángulo y estén en un ángulo mayor al especificado.',
          },
          allowActiveTripsRouteChanges: {
            label: 'Agregar Reservas a Viajes en Ruta',
            description: "Habilitar reservas 'Intentar Unirse' (ej.: Llamadas de Última Hora) para viajes en ruta junto con nuevos viajes.",
          },
          rerouteTripOnBookingUpdate: {
            label: 'Volver a Rutear el Viaje al Actualizar una Reserva',
            description:
              'Cuando está activado, una reserva editada permanece en su viaje. Un viaje en estado Nuevo se vuelve a rutear: la reserva permanece si sigue encajando con las demás reservas, y su conductor permanece si sigue siendo elegible. Un viaje en estado Enviado/Aprobado/En ruta también se vuelve a rutear, así que sus paradas pueden recibir un nuevo orden y nuevos horarios, y todas sus reservas permanecen. Los viajes en estado Listo/Cancelado nunca se modifican. Cuando está desactivado, la reserva editada se quita de su viaje y vuelve al estado Nuevo, salvo que esté Recogido/Dejado/No apareció - entonces permanece y su viaje se vuelve a rutear con ella.',
          },
          vrpRunningTime: {
            label: 'Tiempo de ejecución del VRP',
            description:
              'Límite de tiempo para que la optimización intente mejorar los resultados; ejecuciones más largas dejan espacio para explorar más posibilidades.',
          },
          editOnMap: {
            label: 'Editar en el Mapa',
            description: 'Permite que los usuarios reordenen manualmente las paradas dentro de un viaje arrastrándolas en el mapa.',
          },
          consistentPassengerRouting: {
            label: 'Enrutamiento Consistente de Pasajeros',
            description:
              'Garantiza que el mismo grupo de pasajeros siga siempre la misma ruta hacia y desde la direccion especifica, optimizando la eficiencia del viaje y minimizando la confusion.',
          },
          sameDriverForGroup: {
            label: 'Mismo Conductor para el Grupo',
            description:
              'Asigna el mismo conductor para transportar al grupo de pasajeros tanto en la recogida como en la entrega, proporcionando familiaridad y consistencia.',
          },
          routingMode: {
            label: 'Modo de enrutamiento',
            description: '',
            options: {
              default: 'Predeterminado',
              hClustering: 'H-Clustering',
              vrp: 'VRP',
            },
          },
          defaultWillCallTime: {
            label: 'Desfase de Tiempo Predeterminado de Will Call',
            description:
              'Agregar X minutos a la lógica de desfase de Will Call como predeterminado cuando no exista un atributo relacionado con Will Call',
          },
          enableWillCallTime: {
            label: 'Hora de Will Call activada',
          },
        },
      },
      sameAreaLocation: {
        title: 'Misma zona / Ubicación',
        parameters: {
          mergeReservationsByBoardingArea: {
            label: 'Misma zona de recogida',
            description: 'Las reservas se agruparán juntas solo si la ubicación de recogida está en el mismo polígono.',
          },
          mergeReservationsByBoardingLocation: {
            label: 'Misma ubicación de recogida',
            description: 'Las reservas se agruparán juntas solo si la ubicación de recogida es la misma.',
          },
          mergeReservationsByDropArea: {
            label: 'Misma zona de entrega',
            description: 'Las reservas se agruparán juntas solo si la ubicación de entrega está en el mismo polígono.',
          },
          mergeReservationsByDropLocation: {
            label: 'Misma ubicación de entrega',
            description: 'Las reservas se agruparán juntas solo si la ubicación de entrega es la misma.',
          },
          onlyGroupExactLocations: {
            label: 'Misma ubicación de recogida o entrega',
            description: 'Las reservas se agruparán juntas solo si las ubicaciones de recogida o entrega son las mismas.',
          },
          snapToLocation: {
            label: 'Ajustar a ubicación',
            description:
              'Ajustar automáticamente el origen o destino de la reserva a la ubicación conocida más cercana de nuestro módulo de gestión de ubicaciones internas, si está dentro del radio snapToLocation. El valor está en metros/pies según el formato de configuración del sistema.',
          },
          sameFlightNumber: {
            label: 'Mismo número de vuelo',
            description: 'Las reservas se agruparán solo si el número de vuelo es el mismo.',
          },
        },
      },
      evs: {
        title: 'Vehículos Eléctricos',
        parameters: {
          minimalBatteryThreshold: {
            label: 'Umbral mínimo de batería',
            description:
              'Este es el porcentaje crítico de batería que no deseas que el sistema baje durante tu viaje. Por ejemplo, si se establece en 30%, el sistema intentará mantener tu batería por encima de este nivel.',
          },
        },
      },
      reservationClusters: {
        title: 'Agrupación de Reservas',
        parameters: {
          isClusteringEnabled: {
            label: 'Agrupamiento',
            description: 'Define si los algoritmos de agrupamiento de reservaciones están habilitados o no.',
          },
          clusterSnapTo: {
            label: 'Modo',
            description: 'Define si la dirección del centro del grupo debe cambiarse por una carretera conocida o una estación de autobús.',
            options: {
              address: 'Dirección',
              busStop: 'Parada de Autobús',
            },
          },
          clusterReservationsRadius: {
            label: 'Diámetro',
            description: 'En qué diámetro empezar a combinar reservas juntas en un único punto de recogida/entrega.',
          },
          clusterSnapMaxDistance: {
            label: 'Distancia máxima',
            description:
              'Distancia máxima (en KM/Millas según el sistema definido) en la que la dirección del centro del grupo puede modificarse para una mejor ubicación.',
          },
          snapToShapeRatio: {
            label: 'Paradas/Puntos Prioritarios por Distancia Aérea',
            description:
              'El sistema intentará crear paradas adicionales a lo largo de la ruta si la distancia en línea recta del pasajero es menor que la proporción seleccionada.',
          },
          snapToShapeUnite: {
            label: 'Distancia Mínima entre Paradas Generadas',
            description: 'Distancia mínima entre las paradas creadas.',
          },
          distanceType: {
            label: 'Tipo de Distancia',
            description: 'Define si la distancia al grupo será por Distancia Aérea o Caminando',
            options: {
              airDistance: 'Distancia Aérea',
              walkingDistance: 'Distancia Caminando',
            },
          },
          maxPassengersInCluster: {
            label: 'Número Máximo de Pasajeros en el Grupo',
            description:
              'Número máximo de pasajeros permitidos en un grupo. Esta configuración sigue siendo editable incluso cuando el agrupamiento está deshabilitado.',
          },
          keepVrpClusters: {
            label: 'Mantener Grupos de VRP',
            description:
              'Cuando está habilitado, la salida de VRP permanece agrupada. Cuando está deshabilitado, los grupos de VRP se dividen en reservas individuales para reenrutamiento.',
          },
        },
      },
      smoothRoute: {
        title: 'Ruta Suave',
        parameters: {
          smoothRouteEnabled: {
            label: 'Ruta Suave',
            description:
              'Define si la dirección central del grupo debe cambiarse por una calle conocida, estación de autobús o mediante Ruta Suave.',
          },
          smoothRouteRadius: {
            label: 'Radio de Ruta Suave',
            description:
              'Define la distancia máxima a pie (en metros) que se puede requerir que un pasajero camine cuando la "Ruta Suave" está habilitada. Esta configuración solo tiene efecto si la "Ruta Suave" está activada.',
          },
        },
      },
      traffic: {
        title: 'Editar configuración de tráfico',
        parameters: {
          trafficRouteEnabled: {
            label: 'Tráfico',
            modalHeader: 'Advertencia: Configuración sensible de tráfico',
            modalBody:
              'Estás a punto de editar configuraciones avanzadas de tráfico. Estos valores afectan directamente cómo se calculan las rutas y pueden alterar significativamente el comportamiento del sistema. Por favor, continúa solo si comprendes completamente las implicaciones. Para confirmar, escribe "traffic" abajo y haz clic en "Confirmar".',
          },
          minTraffic: {
            label: 'Mínimo',
            description: 'Proporción mínima entre la duración del tráfico y la duración del servidor de mapas',
          },
          baseTraffic: {
            label: 'Base',
            description:
              'Multiplica todas las duraciones calculadas por una relación base (X). Los valores más altos aumentan los tiempos de viaje estimados.',
          },
          hourTraffic: {
            label: 'Hora',
            description:
              'Un arreglo de 24 ratios horarios (00:00–23:59). Cada valor ajusta los multiplicadores de duración del viaje según la hora del día.',
          },
        },
      },
    },
  },
  assignment: {
    title: 'Asignación de Conductores',
    pageTitle: 'Configuraciones de Asignación de Conductores',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          distanceFromTripScore: {
            label: 'Distancia',
            description: 'Da mayor prioridad si deseas aumentar las probabilidades de que el conductor más cercano al viaje sea asignado.',
          },
          timeFromTripScore: {
            label: 'Tiempo',
            description:
              'Da mayor prioridad si deseas aumentar las probabilidades de que el conductor que pueda llegar más rápido al punto de partida sea asignado.',
          },
          gapTimeScore: {
            label: 'Inactividad',
            description:
              'Una mayor prioridad aumentará las probabilidades de que se asigne un conductor que haya estado esperando más tiempo por su próximo trabajo.',
          },
          ifTripDone: {
            label: 'Número de viajes',
            description:
              'Cuanto mayor sea la prioridad, mayores serán las probabilidades de que alguien ya asignado sea asignado nuevamente. Da menor prioridad para equilibrar los viajes entre conductores activos y mayor prioridad para tener la menor cantidad de conductores necesarios.',
          },
          perTripDone: {
            label: 'Por viaje completado',
            description: 'Cuanto mayor sea la prioridad, más aumenta cada viaje completado las probabilidades de que el conductor sea asignado nuevamente.',
          },
          accumulatedSalaryScore: {
            label: 'Ingresos',
            description:
              'Da alta prioridad si deseas equilibrar la cantidad de conductores según sus salarios (usando más conductores). Da baja prioridad si deseas usar la menor cantidad de conductores.',
          },
          algorithmCode: {
            label: 'Código del Algoritmo',
            options: {
              dateOrdering: 'Ordenación por Fecha',
              dynamicOrdering: 'Ordenación Dinámica',
            },
          },
          driverAssignmentStrategy: {
            label: 'Estrategia de Asignación de Conductores',
            options: {
              minimumFleetUsage: 'Uso Mínimo de la Flota',
              balanceAvailableDrivers: 'Balance – Conductores Disponibles',
              balanceMinimumRequiredDrivers: 'Balance – Conductores Mínimos Requeridos',
            },
          },
        },
      },
      limits: {
        title: 'Límites',
        parameters: {
          maxTripsPerDriver: {
            label: 'Máximo de viajes',
            description: 'La cantidad máxima de viajes que un conductor puede ser asignado en una solicitud dada.',
          },
          maxAccumulatedSalary: {
            label: 'Precio máximo',
            description:
              'La suma máxima de salario que un conductor podría ganar en el proceso de asignación (y luego otros conductores tendrán prioridad).',
          },
        },
      },
      advanced: {
        title: 'Configuraciones Avanzadas',
        parameters: {
          distanceFromHomeScore: {
            label: 'Distancia desde casa',
            description: 'Si deseas mantener a los conductores cerca de casa (su ubicación de inicio), debes dar una alta prioridad.',
          },
          nextTripDistanceScore: {
            label: 'Distancia del próximo viaje',
            description: 'Cuando "llenamos huecos" en el horario de un conductor, priorizamos según la distancia del próximo viaje.',
          },
          idleBonusMinutes: {
            label: 'Minutos de bonificación por inactividad',
            description: 'Período que el conductor necesita permanecer inactivo para recibir la bonificación ${}.',
          },
          idleBonusScore: {
            label: 'Puntaje de bonificación por inactividad',
            description: 'La cantidad de puntos añadidos al puntaje del conductor después de estar inactivo durante ${} minutos.',
          },
          scorePerEmptySeats: {
            label: 'Por asiento vacío',
            description:
              'Usa esta configuración para especificar tu preferencia por minimizar los asientos vacíos en el vehículo (cuanto más negativo el valor, mayor será la evitación).',
          },
          assignPriorityBonusMax: {
            label: 'Bono de prioridad de reglas personalizadas – Máximo',
            description: 'Puntuación máxima otorgada al atributo de mayor prioridad al asignar viajes',
          },
          assignPriorityBonusMin: {
            label: 'Bono de prioridad de reglas personalizadas – Mínimo',
            description: 'Puntuación mínima otorgada al atributo de menor prioridad al asignar viajes',
          },
          areaMatchScore: {
            label: 'Coincidencia de zona',
            description: 'Cuanto mayor sea la prioridad, más probable será que se asigne un conductor que pertenezca al zona del viaje.',
          },
          scorePerVehicleCost: {
            label: 'Costo por vehículo',
            description: '',
          },
          perAssignmentScore: {
            label: 'Puntuación por asignación',
            description:
              'Añade una puntuación por cada viaje asignado a un conductor. Los valores más altos desalentarán asignar múltiples viajes al mismo conductor.',
          },
          perLoadedDistance: {
            label: 'Puntuación por distancia cargada',
            description:
              'Añade una puntuación basada en la distancia de los viajes con pasajeros (millas cargadas). Los valores más altos priorizan viajes más cortos y reducen la distancia total cargada.',
          },
          isAssignBlocked: {
            label: 'Bloquear asignación automática',
            description: 'Cuando la asignación automática está desactivada, los perfiles seleccionados no se asignarán automáticamente.',
          },
          assignBlockedProfiles: {
            label: 'Perfiles bloqueados',
            description: 'Elige qué perfiles no deben ser asignados automáticamente por la plataforma.',
          },
          assignBlockedAttributes: {
            label: 'Atributos bloqueados',
            description: 'Elige qué atributos no deben ser asignados automáticamente por la plataforma.',
          },
          allowFlexibleTimes: {
            label: 'Permitir horarios flexibles',
            description:
              'Optimiza las asignaciones de conductores y reduce el uso de vehículos modificando los horarios de salida de los viajes, respetando las reglas de retraso máximo y adelanto máximo de abordaje.',
          },
          unassignOnVehicleChange: {
            label: 'Deshabilitar desasignación de conductor al cambiar de vehículo',
            description:
              'Cambiar un conductor a otro vehículo con atributos coincidentes de "Coincidencia de Atributos de Reserva de Conductor/Vehículo" no desasignará automáticamente el viaje del conductor.',
          },
          consistentSupplier: {
            label: 'Proveedor Consistente',
            description:
              'El sistema asignará conductores del mismo proveedor a las reservaciones de un pasajero dentro de un solo día, sin considerar las limitaciones del conductor.',
          },
          assignBySupplier: {
            label: 'Asignar por Proveedor',
            description: '',
          },
          supplierPriorityMode: {
            label: 'Orden del Proveedor',
            description: '',
            options: {
              byRank: 'Por Clasificación',
              byTier: 'Por Nivel',
            },
          },
          shiftAllocationWeight: {
            label: 'Disponibilidad del Conductor',
            description: 'Cantidad de puntos agregados a la puntuación del conductor por duración del turno',
          },
        },
      },
      driverShifts: {
        title: 'Turnos de Conductores',
        parameters: {
          ignoreDriverShifts: {
            label: 'Ignorar turnos de conductores',
            description: 'El proceso de asignación de conductores tiene en cuenta los turnos de los conductores.',
          },
          startShiftWithTrip: {
            label: 'Comenzar turno con viaje',
            description:
              'Asigna conductores a viajes al inicio de su turno sin considerar el tiempo de viaje hasta la primera recogida. Los conductores son responsables de llegar a tiempo a la ubicación de recogida inicial al inicio del turno.',
          },
          maxShiftHours: {
            label: 'Tiempo máximo del turno',
            description:
              'La duración máxima (en horas) de un turno de conductor. El motor no permitirá que un conductor sea considerado activo más allá de esta cantidad de horas.',
          },
          shiftGap: {
            label: 'Intervalo entre turnos',
            description: 'Establece la duración obligatoria del descanso entre turnos consecutivos.',
          },
          driverRestAfterTrip: {
            label: 'Aplicar descanso',
            description: 'Se solicita a los conductores que tomen un descanso después de cada viaje.',
          },
          ignoreDropoffTime: {
            label: 'Ignorar hora de descenso',
            description: 'El sistema asignará viajes a conductores incluso si la hora de descenso queda fuera de su disponibilidad.',
          },
          shiftBuffer: {
            label: 'Margen de turno',
            description: 'Permite asignar viajes que terminan hasta X minutos después del final del turno.',
          },
        },
      },
      mobileApp: {
        title: 'Aplicación de Turnos de Conductores',
        parameters: {
          allowShiftCreation: {
            label: 'Permitir Creación de Turnos',
            description: 'Permitir que los conductores creen nuevos turnos en su horario.',
          },
          allowBreaksInShifts: {
            label: 'Permitir Descansos en los Turnos',
            description: 'Permitir que los conductores incluyan períodos de descanso dentro de sus turnos.',
          },
          enableShiftDeletion: {
            label: 'Permitir Eliminación de Turnos',
            description: 'Permitir que los conductores eliminen sus turnos programados si es necesario.',
          },
          minimumShiftCancellationNotice: {
            label: 'Aviso Mínimo para Cancelación de Turno',
            description: 'Establecer el tiempo mínimo requerido antes de que comience un turno para que el conductor pueda cancelarlo.',
          },
          maxShiftAvailability: {
            label: 'Disponibilidad Máxima de Turno',
            description: 'Definir el período de disponibilidad más largo que un conductor puede establecer para sí mismo.',
          },
          enableRecurringShifts: {
            label: 'Permitir Turnos Recurrentes',
            description: 'Permitir que los conductores creen turnos recurrentes en un rango de fechas personalizado.',
          },
        },
      },
      virtualReal: {
        title: 'Virtual vs Real',
        parameters: {
          assignmentType: {
            label: 'Tipo de asignación',
            description: 'Modo de asignación predeterminado (Conductores reales vs Conductores virtuales).',
            options: {
              virtual: 'Virtual',
              real: 'Real',
            },
          },
          addVirtualDrivers: {
            label: 'Llenar con conductores virtuales',
            description: 'Asigna automáticamente conductores virtuales a los viajes cuando no hay conductores reales disponibles.',
          },
          defaultCarLocation: {
            label: 'Ubicación predeterminada del vehículo',
            description: 'La ubicación de inicio predeterminada a considerar para un vehículo/conductor si no se especifica.',
          },
          defaultCarSeats: {
            label: 'Asientos predeterminados',
            description: 'Número predeterminado de asientos a considerar para un vehículo si no se define.',
          },
        },
      },
    },
  },
  distribution: {
    title: 'Distribución',
    pageTitle: '',
    groups: {
      base: {
        title: 'Peso de KPIs de Flotas',
        parameters: {
          onTimePerformance: {
            label: 'Cumplimiento a Tiempo',
            description: '',
          },
          noShowRate: {
            label: 'Tasa de Ausencias',
            description: '',
          },
          cancellationRate: {
            label: 'Tasa de Cancelaciones',
            description: '',
          },
          acceptanceRate: {
            label: 'Tasa de Aceptación',
            description: '',
          },
          responseTime: {
            label: 'Tiempo de Respuesta',
            description: '',
          },
          costEfficiency: {
            label: 'Eficiencia de Costos',
            description: '',
          },
        },
      },
    },
  },
  advancedSettingsPopups: {
    maxDurationByDistance: {
      title: 'Configurar Duración Máxima por Distancia',
      form: {
        fields: {
          startKm: 'Desde ({{unit}})',
          endKm: 'Hasta ({{unit}})',
          durationMinutes: 'Duración Máxima (min)',
        },
        btnAddRange: 'Agregar Rango',
        btnSubmit: 'Guardar',
        btnClose: 'Cerrar',
      },
    },
  },
};

export default settings;
